/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RecordIdentityProviderConnectionAgentRequestBody,
  RecordIdentityProviderConnectionAgentRequestBody$Outbound,
  RecordIdentityProviderConnectionAgentRequestBody$outboundSchema,
} from "../components/recordidentityproviderconnectionagentrequestbody.js";

export type RecordIdentityProviderConnectionAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RecordIdentityProviderConnectionAgentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  recordIdentityProviderConnectionAgentRequestBody:
    RecordIdentityProviderConnectionAgentRequestBody;
};

/** @internal */
export type RecordIdentityProviderConnectionAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RecordIdentityProviderConnectionAgentSecurity$outboundSchema:
  z.ZodMiniType<
    RecordIdentityProviderConnectionAgentSecurity$Outbound,
    RecordIdentityProviderConnectionAgentSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function recordIdentityProviderConnectionAgentSecurityToJSON(
  recordIdentityProviderConnectionAgentSecurity:
    RecordIdentityProviderConnectionAgentSecurity,
): string {
  return JSON.stringify(
    RecordIdentityProviderConnectionAgentSecurity$outboundSchema.parse(
      recordIdentityProviderConnectionAgentSecurity,
    ),
  );
}

/** @internal */
export type RecordIdentityProviderConnectionAgentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RecordIdentityProviderConnectionAgentRequestBody:
    RecordIdentityProviderConnectionAgentRequestBody$Outbound;
};

/** @internal */
export const RecordIdentityProviderConnectionAgentRequest$outboundSchema:
  z.ZodMiniType<
    RecordIdentityProviderConnectionAgentRequest$Outbound,
    RecordIdentityProviderConnectionAgentRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      recordIdentityProviderConnectionAgentRequestBody:
        RecordIdentityProviderConnectionAgentRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        recordIdentityProviderConnectionAgentRequestBody:
          "RecordIdentityProviderConnectionAgentRequestBody",
      });
    }),
  );

export function recordIdentityProviderConnectionAgentRequestToJSON(
  recordIdentityProviderConnectionAgentRequest:
    RecordIdentityProviderConnectionAgentRequest,
): string {
  return JSON.stringify(
    RecordIdentityProviderConnectionAgentRequest$outboundSchema.parse(
      recordIdentityProviderConnectionAgentRequest,
    ),
  );
}
